import __base_store from '@/store/__base_store'

/**
 * Store de comisiones por venta terminada.
 */
export default __base_store({
	state: {
		model_name: 'venta_terminada_commission',
	},
})

